import React, { useCallback, useState } from 'react';
import { useParams } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';

import { useGetInvestmentFundQuery } from 'api/main';
import { texts } from 'utils/languages/fr';

import { ListContainer } from 'components';
import { Box, Breadcrumbs, Link, Tab, Typography } from '@mui/material';
import * as icons from 'mdi-material-ui';
import FundInfo from './FundInfo';
import FundDocuments from './FundDocuments';
import FundShareCategories from './share-categories/FundShareCategories';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

const FundAttributes = () => {
    const { fundId } = useParams();
    const { data: fund } = useGetInvestmentFundQuery(fundId, { skip: !fundId });

    const [value, setValue] = useState('1');

    const handleTab = useCallback((_e, newValue) => {
        setValue(newValue);
    }, []);

    return (
        <ListContainer>
            <Breadcrumbs separator={<icons.MenuRight />} aria-label="breadcrumb">
                <Link
                    underline="hover"
                    href="/fund-management"
                    to="/fund-management"
                    component={RouterLink}
                >
                    {texts.FUND}
                </Link>
                {fundId ? (
                    <Link
                        underline="hover"
                        href={`/fund-management/${fundId}/attributes`}
                        to={`/fund-management/${fundId}/attributes`}
                        component={RouterLink}
                    >
                        {texts.FUND_ATTRIBUTES} - {fund?.name}
                    </Link>
                ) : (
                    <Typography>{texts.CREATE_INVESTMENT_FUND}</Typography>
                )}
            </Breadcrumbs>
            <Box sx={{ padding: 2 }}>
                <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <TabList
                            onChange={handleTab}
                            aria-label="lab API tabs example"
                            sx={{ width: 'auto' }}
                        >
                            <Tab disableRipple label={texts.INFOS} value="1" />
                            <Tab
                                disableRipple
                                disabled={!fundId}
                                label={texts.DOCUMENTS}
                                value="2"
                            />
                            <Tab
                                disableRipple
                                disabled={!fundId}
                                label={texts.CATEGORIES}
                                value="3"
                            />
                        </TabList>
                    </Box>
                    <TabPanel value="1">
                        <FundInfo fundId={+fundId} />
                    </TabPanel>
                    <TabPanel value="2">
                        <FundDocuments fundId={+fundId} />
                    </TabPanel>
                    <TabPanel value="3">
                        <FundShareCategories fundId={+fundId} />
                    </TabPanel>
                </TabContext>
            </Box>
        </ListContainer>
    );
};

export default FundAttributes;
